import { createBaseLogger } from '@powersync/common';
import { SharedSyncImplementation } from './SharedSyncImplementation.js';
import { WorkerClient } from './WorkerClient.js';
const _self = self;
const logger = createBaseLogger();
logger.useDefaults();
const sharedSyncImplementation = new SharedSyncImplementation();
_self.onconnect = async function (event) {
    const port = event.ports[0];
    new WorkerClient(sharedSyncImplementation, port);
};
